import { Card, CardActionArea, CardMedia } from "@material-ui/core";
import React, { Component } from "react";
import Carousel from "react-material-ui-carousel";

export default class AdsCarousal extends Component {
  constructor(props) {
    super(props);
    console.log(props);
  }

  render() {
    let adsImages = this.props.adverts.map((item, i) => (
      <Card elevation={2} key={i}>
        <CardActionArea href={item.imgUrl} target="_blank">
          <CardMedia component="img" image={item.imgSrc} alt="ad image" />
        </CardActionArea>
      </Card>
    ));

    return (
      <div>
        <Carousel
          className="car"
          autoPlay={false} // Disable auto-scroll
          navButtonsProps={{
            style: {
              borderRadius: "50%",
              height: "20px",
              width: "20px",
              backgroundColor: "black",
              color: "white",
              opacity: 0.2, // Ensure buttons are always fully visible
              transition: "none", // Remove hover transition effect
            },
          }}
          navButtonsWrapperProps={{
            style: {
              visibility: "visible", // Ensure the buttons are always visible
            },
          }}
        >
          {adsImages}
        </Carousel>
      </div>
    );
  }
}